import { Action, createReducer, on } from '@ngrx/store';
import { setAuthStateAction } from '../actions/auth.action';

export interface AuthReducerInitialState {
  emailToBeVerified: string | null;
}

export const initialState: AuthReducerInitialState = {
  emailToBeVerified: null,
};

const _authReducer = createReducer(
  initialState,
  on(setAuthStateAction, (state, payload) => {
    return {
      ...state,
      ...payload,
    };
  }),
);

export function authReducer(state: AuthReducerInitialState | undefined, action: Action) {
  return _authReducer(state, action);
}
